import { ChangeDetectorRef, Component, EventEmitter, Input, Output, Renderer2, ViewChild, Pipe, SecurityContext, NgModule } from '@angular/core';
import { BehaviorSubject, forkJoin, fromEvent, ReplaySubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, takeUntil, tap } from 'rxjs/operators';
import elementResizeDetectorMaker from 'element-resize-detector';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/platform-browser';

const _c0 = ["iframe"];
function NgMagicIframeComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} }
const _c1 = ["*"];
class NgMagicIframeComponent {
    /**
     * @param {?} renderer
     * @param {?} cdr
     */
    constructor(renderer, cdr) {
        this.renderer = renderer;
        this.cdr = cdr;
        this.iframeEvent = new EventEmitter();
        this.$iframeClick = new ReplaySubject(1);
        this.$iframeKeyUp = new ReplaySubject(1);
        this.$iframeUnload = new ReplaySubject(1);
        this.$loading = new BehaviorSubject(true);
        this.eventListeners = [];
        this.$unsubscribe = new Subject();
        this.$bodyHeight = new Subject();
        this._autoResize = true;
        this._resizeDebounceMillis = 50;
    }
    /**
     * @return {?}
     */
    get resizeDebounceMillis() {
        return this._resizeDebounceMillis;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set resizeDebounceMillis(value) {
        if (this._resizeDebounceMillis !== value) {
            this.updateStyles();
        }
        this._resizeDebounceMillis = value;
    }
    /**
     * @return {?}
     */
    get autoResize() {
        return this._autoResize;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set autoResize(value) {
        this._autoResize = value;
    }
    /**
     * @return {?}
     */
    get styleUrls() {
        return this._styleUrls;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set styleUrls(value) {
        this._styleUrls = value;
    }
    /**
     * @return {?}
     */
    get styles() {
        return this._styles;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set styles(value) {
        this._styles = value;
    }
    /**
     * @return {?}
     */
    get source() {
        return this._source;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set source(value) {
        this._source = value;
    }
    /**
     * @return {?}
     */
    updateStyles() {
        this.$styling = this.$bodyHeight.pipe(distinctUntilChanged(), debounceTime(this.resizeDebounceMillis), tap(val => this.emitEvent('iframe-resized')), map((height) => ({ 'height.px': height })));
    }
    /**
     * @param {?} styleUrls
     * @return {?}
     */
    addStyleSheets(styleUrls) {
        if (styleUrls.length > 0) {
            // create placeholder for subjects
            /** @type {?} */
            const loadSubjects = [];
            // loop through all style sheets...
            styleUrls.map((styleUrl) => {
                // create link element
                /** @type {?} */
                const linkElement = this.iframeDocument.createElement('link');
                linkElement['rel'] = 'stylesheet';
                linkElement['type'] = 'text/css';
                linkElement['href'] = styleUrl;
                // create load subject that will emit once the stylesheet has loaded
                /** @type {?} */
                const loadSubject = new Subject();
                loadSubjects.push(loadSubject);
                // listen to load event on link
                /** @type {?} */
                const stylesheetLoadListener = this.renderer.listen(linkElement, 'load', (test) => {
                    this.iframeBody.style.overflow = 'inherit';
                    this.emitEvent('iframe-stylesheet-loaded', styleUrl);
                    loadSubject.next(styleUrl);
                    loadSubject.complete();
                    return true;
                });
                // push listener to array so that we can remove them later
                this.eventListeners.push(stylesheetLoadListener);
                // add link to iframe head
                this.iframeDocument.head.appendChild(linkElement);
                // emit load event
                this.emitEvent('iframe-stylesheet-load', styleUrl);
            });
            forkJoin(loadSubjects)
                .pipe(takeUntil(this.$unsubscribe))
                .subscribe(res => {
                if (styleUrls.length > 1) {
                    this.emitEvent('iframe-all-stylesheets-loaded', styleUrls);
                }
                this.$loading.next(false);
            });
        }
    }
    /**
     * @param {?} styles
     * @return {?}
     */
    addCss(styles) {
        /** @type {?} */
        const styleElement = this.iframeDocument.createElement('style');
        styleElement.appendChild(this.iframeDocument.createTextNode(styles));
        this.iframeDocument.getElementsByTagName('head')[0].appendChild(styleElement);
        this.emitEvent('iframe-styles-added');
    }
    /**
     * @param {?} body
     * @param {?} style
     * @return {?}
     */
    addElementResizeDetector(body, style) {
        this.elementResizeDetector = elementResizeDetectorMaker({ strategy: 'scroll' });
        this.elementResizeDetector.listenTo(body, () => {
            /** @type {?} */
            const offsetHeight = body.offsetHeight;
            /** @type {?} */
            const marginTop = parseInt(style.getPropertyValue('margin-top'), 10);
            /** @type {?} */
            const marginBottom = parseInt(style.getPropertyValue('margin-bottom'), 10);
            /** @type {?} */
            const height = offsetHeight + marginTop + marginBottom;
            this.$bodyHeight.next(height);
        });
    }
    /**
     * @return {?}
     */
    removeElementResizeDetector() {
        if (this.iframeBody && this.elementResizeDetector) {
            this.elementResizeDetector.uninstall(this.iframeBody);
        }
    }
    /**
     * @param {?} eventName
     * @param {?=} resource
     * @return {?}
     */
    emitEvent(eventName, resource) {
        /** @type {?} */
        const iframeEvent = { event: eventName, src: this.activeSource };
        if (resource) {
            iframeEvent.resource = resource;
        }
        this.iframeEvent.emit(iframeEvent);
    }
    /**
     * @return {?}
     */
    reload() {
        if (this.iframeDocument && this.iframeDocument.location) {
            this.iframeDocument.location.reload();
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.activeSource = this.source;
        this.$loading.pipe(filter(value => value === false || value === null), takeUntil(this.$unsubscribe)).subscribe((res) => {
            this.emitEvent(res === null ? 'iframe-loaded-with-errors' : 'iframe-loaded');
        });
        this.updateStyles();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        /** @type {?} */
        const iframe = this.elementRef.nativeElement;
        this.$iframeClick
            .pipe(takeUntil(this.$unsubscribe)).subscribe((res) => {
            this.emitEvent('iframe-click');
        });
        this.$iframeKeyUp
            .pipe(takeUntil(this.$unsubscribe)).subscribe((res) => {
            this.emitEvent('iframe-keyup');
        });
        this.$iframeUnload
            .pipe(takeUntil(this.$unsubscribe)).subscribe((res) => {
            this.$loading.next(true);
            this.emitEvent('iframe-unloaded');
            this.iframeBody.style.overflow = 'hidden';
            this.cdr.detectChanges();
        });
        fromEvent(iframe, 'load')
            .pipe(takeUntil(this.$unsubscribe))
            .subscribe((res) => {
            try {
                this.activeSource = iframe.contentWindow.location.href;
                // declare iframe document and body
                this.iframeDocument = iframe.contentDocument;
                this.iframeBody = this.iframeDocument.body;
                // add inline css
                if (this.styles) {
                    this.addCss(this.styles);
                }
                // add external stylesheets
                if (this.styleUrls && this.styleUrls.length > 0) {
                    this.addStyleSheets(this.styleUrls);
                }
                else {
                    this.$loading.next(false);
                }
                // add element resize detector
                if (this.autoResize) {
                    this.addElementResizeDetector(this.iframeBody, iframe.contentWindow.getComputedStyle(this.iframeBody));
                }
                // add click listener
                /** @type {?} */
                const clickListener = this.renderer.listen(iframe.contentWindow, 'click', ($event) => this.$iframeClick.next($event));
                this.eventListeners.push(clickListener);
                // add key up listener
                /** @type {?} */
                const keyUpListener = this.renderer.listen(iframe.contentWindow, 'keyup', ($event) => this.$iframeKeyUp.next($event));
                this.eventListeners.push(keyUpListener);
                // add unload listener
                /** @type {?} */
                const unloadListener = this.renderer.listen(iframe.contentWindow, 'beforeunload', ($event) => this.$iframeUnload.next($event));
                this.eventListeners.push(unloadListener);
            }
            catch (error) {
                console.log('Event listeners and/or styles and resize listener could not be added due to a cross-origin frame error.');
                console.warn(error);
                this.$loading.next(null);
            }
        });
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.$unsubscribe.next();
        this.$unsubscribe.complete();
        // detach event listeners
        this.eventListeners.map((listener) => listener());
        // if auto resize...
        if (this.autoResize) {
            // ...try and remove element resize detector
            this.removeElementResizeDetector();
        }
    }
}
NgMagicIframeComponent.ɵfac = function NgMagicIframeComponent_Factory(t) { return new (t || NgMagicIframeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NgMagicIframeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgMagicIframeComponent, selectors: [["seb-ng-magic-iframe"]], viewQuery: function NgMagicIframeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.elementRef = _t.first);
    } }, inputs: { resizeDebounceMillis: "resizeDebounceMillis", autoResize: "autoResize", styleUrls: "styleUrls", styles: "styles", source: "source" }, outputs: { iframeEvent: "iframeEvent" }, ngContentSelectors: _c1, decls: 6, vars: 9, consts: [["class", "seb-iframe-loading", 4, "ngIf"], ["frameborder", "0", "scrolling", "no", 1, "seb-iframe", 3, "src", "ngStyle"], ["iframe", ""], [1, "seb-iframe-loading"]], template: function NgMagicIframeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NgMagicIframeComponent_div_0_Template, 2, 0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵelement(2, "iframe", 1, 2);
        ɵngcc0.ɵɵpipe(4, "safe");
        ɵngcc0.ɵɵpipe(5, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 3, ctx.$loading));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind1(4, 5, ctx.source), ɵngcc0.ɵɵsanitizeResourceUrl)("ngStyle", ɵngcc0.ɵɵpipeBind1(5, 7, ctx.$styling));
    } }, dependencies: function () { return [ɵngcc1.NgIf, ɵngcc1.NgStyle, ɵngcc1.AsyncPipe, SafePipe]; }, styles: ["[_nghost-%COMP%] {\n            position: relative;\n            display: block;\n            overflow: hidden;\n        }\n        .seb-iframe[_ngcontent-%COMP%] {\n            overflow: hidden;\n            width: 100%;\n        }\n        .seb-iframe-loading[_ngcontent-%COMP%] {\n            height: 100%;\n            width: 100%;\n            position: absolute;\n            z-index: 1;\n        }\n        .seb-iframe-loading[_ngcontent-%COMP%]::after {\n            background: #fff;\n            content: '';\n            display: block;\n            height: 100%;\n            position: absolute;\n            top: 0;\n            width: 100%;\n            z-index: -1;\n            left: 0;\n        }"] });
/** @nocollapse */
NgMagicIframeComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ChangeDetectorRef }
];
NgMagicIframeComponent.propDecorators = {
    resizeDebounceMillis: [{ type: Input }],
    autoResize: [{ type: Input }],
    styleUrls: [{ type: Input }],
    styles: [{ type: Input }],
    source: [{ type: Input }],
    iframeEvent: [{ type: Output }],
    elementRef: [{ type: ViewChild, args: ['iframe',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgMagicIframeComponent, [{
        type: Component,
        args: [{ selector: 'seb-ng-magic-iframe', template: `
        <div class="seb-iframe-loading" *ngIf="$loading | async">
            <ng-content></ng-content>
        </div>
        <iframe #iframe [src]="source | safe" frameborder="0" class="seb-iframe" [ngStyle]="$styling | async" scrolling="no"></iframe>
    `, styles: ["\n        :host {\n            position: relative;\n            display: block;\n            overflow: hidden;\n        }\n        .seb-iframe {\n            overflow: hidden;\n            width: 100%;\n        }\n        .seb-iframe-loading {\n            height: 100%;\n            width: 100%;\n            position: absolute;\n            z-index: 1;\n        }\n        .seb-iframe-loading::after {\n            background: #fff;\n            content: '';\n            display: block;\n            height: 100%;\n            position: absolute;\n            top: 0;\n            width: 100%;\n            z-index: -1;\n            left: 0;\n        }\n    "] }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { iframeEvent: [{
            type: Output
        }], resizeDebounceMillis: [{
            type: Input
        }], autoResize: [{
            type: Input
        }], styleUrls: [{
            type: Input
        }], styles: [{
            type: Input
        }], source: [{
            type: Input
        }], elementRef: [{
            type: ViewChild,
            args: ['iframe']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class SafePipe {
    /**
     * @param {?} sanitizer
     */
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} url
     * @return {?}
     */
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.sanitizer.sanitize(SecurityContext.URL, url));
    }
}
SafePipe.ɵfac = function SafePipe_Factory(t) { return new (t || SafePipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DomSanitizer, 16)); };
SafePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "safe", type: SafePipe, pure: true });
/** @nocollapse */
SafePipe.ctorParameters = () => [
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SafePipe, [{
        type: Pipe,
        args: [{
                name: 'safe'
            }]
    }], function () { return [{ type: ɵngcc2.DomSanitizer }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class NgMagicIframeModule {
}
NgMagicIframeModule.ɵfac = function NgMagicIframeModule_Factory(t) { return new (t || NgMagicIframeModule)(); };
NgMagicIframeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgMagicIframeModule });
NgMagicIframeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgMagicIframeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [NgMagicIframeComponent, SafePipe],
                exports: [NgMagicIframeComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgMagicIframeModule, { declarations: function () { return [NgMagicIframeComponent, SafePipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgMagicIframeComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { NgMagicIframeComponent, NgMagicIframeModule, SafePipe as ɵa };

